module.exports = __webpack_public_path__ + "img/blank-comic-book_B0991C6NBW.977924df.jpg";